import React from 'react';

function About() {
  return (
    <>
      <div className="aboutContainer">
        <div className="textArea">
          <h2>{process.env.REACT_APP_NAME}について</h2>
          <p>「速さと正確さを兼ね備えた{process.env.REACT_APP_NAME}」は、最先端の人工知能技術を活用し、迅速かつ正確な韓国語の文法添削を提供するサービスです。従来の人間による添削と比較して、このAIサービスは時間とコストの大幅な節約を実現します。</p>
          <hr className="hr"></hr>
          <h3>魅力1.スピード</h3>
          <p>このサービスの最大の特徴は、スピード感あふれる添削能力です。文章を入力した瞬間から、AIが瞬時に文法、語彙、表現の正確さを分析し、即座にフィードバックを提供します。これにより、ユーザーは待ち時間を気にすることなく、リアルタイムで自身の韓国語能力の向上を感じることができます。</p>
          <hr className="hr"></hr>
          <h3>魅力2.品質担保</h3>
          <p>人間の添削者に比べて、AIは疲れることなく一貫した品質を維持します。人間による添削は、時間と労力がかかるうえ、品質がその人のスキルや状態に依存します。しかし、AI添削は一定の高い品質を保ち続けるため、常に信頼できる結果を得ることができます。</p>
          <hr className="hr"></hr>
          <h3>魅力3.低コスト</h3>
          <p>コスト面でも、AI添削サービスは顕著な利点を持っています。人間による添削サービスは専門知識を要するため高価になりがちですが、AI添削は大幅にコストを削減し、より多くの人々が利用できる価格帯を実現しています。これにより、韓国語学習者は、高品質な添削をリーズナブルな価格で享受することが可能になります。</p>
          <hr className="hr"></hr>
        </div>
      </div>
    </>
  )
}

export default About;